import React, { Component } from 'react'
import { ScrollView, View } from 'react-native'

import PropTypes from 'prop-types'

import { VFText } from '@vfgroup-oneplatform/foundation/Components'
import { withTheme, LightThemeColors } from '@vfgroup-oneplatform/foundation/Components/Themes'

import ServiceCard from '../../Components/ServiceCard'
import ServiceCardLoading from '../../Components/ServiceCardLoading'

import styles from './ServiceStep.styles'

class ServiceStep extends Component {
  renderServiceCard = service => {
    const { onServiceItemPress } = this.props

    return (
      <ServiceCard
        key={service.id}
        {...service}
        isLoading={false}
        onServiceItemPress={onServiceItemPress}
      />
    )
  };

  renderServiceCards = isLoading => {
    return isLoading ? (
      <ServiceCardLoading />
    ) : (
      <View style={styles.cardsScroller(this.props.withTray)}>
        {this.props.services.map(this.renderServiceCard)}
      </View>
    )
  };

  render() {

    const { isAdmin } = this.props
    return (
      <ScrollView showsVerticalScrollIndicator={false} style={styles.container}>
        <VFText
          i18nKey={isAdmin ? 'book_appointment_service_step_subtile_admin' : 'book_appointment_service_step_subtile'}
          style={styles.title(this.props.theme)}
        />
        {this.renderServiceCards(this.props.isLoading)}
      </ScrollView>
    )
  }
}

ServiceCard.defaultProps = {
  theme: LightThemeColors,
}

ServiceStep.propTypes = {
  services: PropTypes.arrayOf(PropTypes.object),
  onServiceItemPress: PropTypes.func,
  isLoading: PropTypes.bool,
  theme: PropTypes.shape({
    name: PropTypes.string,
    isDark: PropTypes.bool,
    colors: PropTypes.object,
  }),
  withTray: PropTypes.bool,
}

export default withTheme(ServiceStep)
